import { call, put } from 'redux-saga/effects';
import { Api } from '../../lib/api';
import { getTeam } from '../../redux';
function* handleGetTeam({ payload }) {
    const { teamId } = payload;
    try {
        const response = (yield call(Api.getTeam, teamId));
        // TODO: Add check for team boundaries and trigger `NO_ASSIGNMENTS_ERROR` if no boundaries are found
        yield put(getTeam.success(response.data));
    }
    catch (error) {
        yield put(getTeam.failure(error));
    }
}
export default handleGetTeam;
